import { TreeSelect } from 'antd';
import styled from 'styled-components';

export default styled(TreeSelect)`
	// Add your styles here
`;
